import { DriverDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/driver_events_pb';
import { DriverStatus } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/driver_pb';
import {
  BadgeField,
  Col,
  FieldDisplay,
  IDField,
  ThemeColor,
} from '@rematter/ui-web';

import { driverStatusLabels } from '../enumLabels';

const getStatusColor = (status: DriverStatus): ThemeColor => {
  switch (status) {
    case DriverStatus.AVAILABLE:
      return 'success';
    case DriverStatus.ON_DUTY:
      return 'primary';
    case DriverStatus.OFF_DUTY:
      return 'neutral';
    case DriverStatus.ON_BREAK:
      return 'warning';
    case DriverStatus.INACTIVE:
      return 'failure';
    default:
      return 'neutral';
  }
};

type DriverDeletedDetailProps = {
  event: DriverDeletedEvent;
};

export const DriverDeletedDetail = ({ event }: DriverDeletedDetailProps) => {
  const driver = event.driver;

  if (!driver) {
    return (
      <Col className="@DriverDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@DriverDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          Deleted Driver
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={driver.id?.value} />
          <FieldDisplay label="First Name" value={driver.firstName} />
          <FieldDisplay label="Last Name" value={driver.lastName} />
          <BadgeField
            label="Status"
            value={driverStatusLabels[driver.status]}
            color={getStatusColor(driver.status)}
          />
          <FieldDisplay label="Email" value={driver.email} />
          <FieldDisplay label="Phone" value={driver.phoneNumber} />
          <FieldDisplay label="License Number" value={driver.licenseNumber} />
          <IDField label="User ID" value={driver.userId?.value} />
        </div>
      </Col>
    </Col>
  );
};
